/**
 * settingService.js
 *
 * All settings/configuration-related API calls.
 *
 * Usage:
 *   import { settingService } from 'services/api';
 *   const data = await settingService.getSettings();
 */

import apiClient from '../apiClient';

export const settingService = {
  /** GET /setting — global app settings */
  getSettings: () =>
    apiClient.get('/setting').then((res) => res.data),

  /** POST /branding — fetch white-label branding for a host */
  getBranding: (hostUrl) =>
    apiClient.post('/branding', { host_url: hostUrl }).then((res) => res.data),

  /** POST /send-email/:id */
  sendEmail: (id, body) =>
    apiClient.post(`/send-email/${id}`, body).then((res) => res.data),

  /** GET /export-:path/:id — generic export handler */
  exportData: (path, id) =>
    apiClient.get(`/${path}/${id}`).then((res) => res.data),

  /** GET /maintenance-config */
  getMaintenanceConfig: () =>
    apiClient.get('/maintenance-config').then((res) => res.data),

  /** POST /maintenance-config */
  updateMaintenanceConfig: (data) =>
    apiClient.post('/maintenance-config', data).then((res) => res.data),
};
